import { IAppConfig } from '../interface/IAppConfig';

export enum HTTP_METHOD {
    GET = 'GET',
    POST = 'POST',
    PUT = 'PUT',
    DELETE = 'DELETE'
}

interface IHeaderProperties {
    [key: string]: string;
}

interface IEndPointHeader {
    wso2: IHeaderProperties;
    objectCache: IHeaderProperties;
    wso2Secured: IHeaderProperties;
}

const getHeaders = (filterKey: keyof IEndPointHeader, config: IAppConfig) => {
    const endpointHeaders = {
        wso2: {
            'x-top-host': config.wso2ApiHost,
            'x-top-appname': config.appName
        },
        wso2Secured: {
            'x-top-host': config.wso2ApiHost,
            'x-top-port': '80',
            'x-top-appname': config.appName,
            'x-top-brand': 'TD'
        },
        objectCache: {
            'x-top-appname': config.appName
        }
    };
    return endpointHeaders[filterKey];
};

export const getDefaultOptions = (
    method: HTTP_METHOD,
    props: IAppConfig,
    endPoint: keyof IEndPointHeader,
    body?: object
): RequestInit => {
    const options: RequestInit = {
        method: method,
        headers: {
            'Content-Type': 'application/json'
        }
    };
    const newHeaders = getHeaders(endPoint, props);
    if (body) {
        options.body = JSON.stringify(body);
    }
    options.headers = { ...options.headers, ...newHeaders };
    return options;
};
